<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Bienvenido</h1>
      </v-flex>
      <v-flex xs12 class="text-xs-center" mt-3>
        <p>Home page de usuario</p>
      </v-flex>

      <v-flex xs12 sm6 offset-sm3 class="text-xs-center" mt-5>
        <!-- <v-btn color="primary" to="/signup">Sign Up</v-btn> -->
        <v-btn to="/broadcasts">Broadcasts</v-btn>
        <v-btn to="/upload">Upload</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>